<template>
  <div id="Users" class="view">
    <div class="company_title">
      <h3 v-text="company.name"></h3>
    </div>
    <p>Her kan du aktivere og deaktivere ansatte til å få bruk av firmakonto når de kjøper hos H.C Thaugland</p>
    <ul class="scroll">
      <transition-group name="fade">
        <li v-for="(user, uid) in company.inactive" :key="'i'+uid" class="user">
          <img :src="user.image" alt="Profile Image" />
          <h5 v-text="user.fullname"></h5>
          <button class="delete d4-trash" @click="removeUser(uid, user.fullname)"/>
          <label class="switch">
            <input type="checkbox" :checked="false" name="inactive" @change="setActive(uid)">
            <span class="slider"></span>
          </label>
        </li>
        <li v-for="(user, uid) in company.active" :key="'a'+uid" class="user">
          <img :src="user.image" alt="Profile Image" />
          <h5 v-text="user.fullname"></h5>
          <label class="switch">
            <input type="checkbox" :checked="true" name="active" @change="setInactive(uid)">
            <span class="slider"></span>
          </label>
        </li>
      </transition-group>
    </ul>
  </div>
</template>

<script>
import { FieldValue } from '@/fire'

export default {
  name: 'Users',
  data () {
    return {
      users: [],
    }
  },
  computed: {
    company () {
      return this.$store.state.user.company
    },
  },
  methods: {
    removeUser (uid, fullname) {
      if (window.confirm(`Er du sikker på at du vil fjerne ${fullname} fra selskapet`)) {
        this.company.ref.update({
          [`active.${uid}`]: FieldValue.delete(),
          [`inactive.${uid}`]: FieldValue.delete(),
        })
      }
    },
    setActive (uid) {
      if (!this.company.inactive[uid]) return
      this.company.ref.update({
        [`active.${uid}`]: this.company.inactive[uid],
        [`inactive.${uid}`]: FieldValue.delete(),
      })
    },
    setInactive (uid) {
      if (!this.company.active[uid]) return
      this.company.ref.update({
        [`inactive.${uid}`]: this.company.active[uid],
        [`active.${uid}`]: FieldValue.delete(),
      })
    },
  },
}
</script>

<style lang="scss">
#Users {
  position: absolute;
  top: 0;
  display: block;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;

  .scroll {
    list-style: none;
    padding: 0;
    flex: 1 1 auto;
  }

  .user {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 8px;
    padding: 2px 8px 2px 2px;
    width: 100%;
    margin: 8px 0;
    box-shadow: 0 2px 8px var(--dark-faded);

    img {
      width: 48px;
      height: 48px;
      object-fit: cover;
      border-radius: 8px;
    }

    h5 {
      flex: 1;
      margin: 0 16px;
    }

    .delete {
      vertical-align: middle;
      font-size: 20rem;
      margin: 0 8px;
    }
  }
}
</style>

